<script>

    export let address;
    export let city;
    export let state;

</script>

<!-- <svelte:head>
	<script defer async
	src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBlX45uDec1JpI_nlqac_tV0HIWqivY-9E&callback=initMap">
	</script>
</svelte:head>
 -->

<div class="mapholder2">
    <iframe title="location map" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBlX45uDec1JpI_nlqac_tV0HIWqivY-9E&q={address}, {city} {state}#/">
    </iframe>    
</div>

<style>
    .mapholder2 {
        box-sizing: border-box;
        width: 100% !important;
        height: 100% !important;
    }

    .mapholder2 iframe {
        box-sizing: border-box;
        width: 100% !important;
        height: 100% !important;
    }
</style>